import { type CSSProperties, type FC, type ReactNode } from 'react'
import classNames from 'classnames'
import { onActivateKeyDown } from '../../CrossClient/utils'
import styles from '../Workflows.module.scss'

interface WorkflowTileProps {
  index?: number
  onClick?: () => void
  className?: string
  children: ReactNode
}

export const WorkflowTile: FC<WorkflowTileProps> = ({ index, onClick, className, children }) => (
  <div
    className={classNames(
      'd-flex flex-column align-items-start gap-2 p-3 border zocks-border-color-gray-200 bg-white h-100 rounded-4',
      styles.tile,
      { [styles.tileEnter]: index !== undefined, [styles.tileInteractive]: onClick !== undefined },
      className,
    )}
    style={index === undefined ? undefined : ({ '--tile-index': index } as CSSProperties)}
    {...(onClick ? { role: 'button', tabIndex: 0, onClick, onKeyDown: onActivateKeyDown(onClick) } : {})}
  >
    {children}
  </div>
)
